import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'ordinal',
  standalone: true,
})
export class OrdinalPipe implements PipeTransform {
  private readonly translocoService = inject(TranslocoService);

  transform(index: number): string {
    const currentLang = this.translocoService.getActiveLang();
    const num = index + 1;

    if (currentLang === 'ar') {
      return this.getArabicOrdinal(num);
    }

    return this.getEnglishOrdinal(num);
  }

  private getEnglishOrdinal(num: number): string {
    const suffix = (() => {
      switch (num) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    })();
    return `${num}${suffix} action`;
  }

  private getArabicOrdinal(num: number): string {
    const ordinalMap: Record<number, string> = {
      1: 'الأول',
      2: 'الثاني',
      3: 'الثالث',
      4: 'الرابع',
      5: 'الخامس',
    };

    // For numbers beyond 20, use a simpler pattern with the number
    if (num > 20) {
      return `الإجراء ${num}`;
    }

    const ordinal = ordinalMap[num] || String(num);
    return `الإجراء ${ordinal}`;
  }
}
